export const GET_ALL_VEHICLES_REQUEST = "GET_ALL_VEHICLES_REQUEST";
export const GET_ALL_VEHICLES_SUCCESS = "GET_ALL_VEHICLES_SUCCESS";
export const GET_ALL_VEHICLES_FAILURE = "GET_ALL_VEHICLES_FAILURE";

export const ADD_VEHICLE_REQUEST = "ADD_VEHICLE_REQUEST";
export const ADD_VEHICLE_SUCCESS = "ADD_VEHICLE_SUCCESS";
export const ADD_VEHICLE_FAILURE = "ADD_VEHICLE_FAILURE";

export const UPDATE_VEHICLE_REQUEST = "UPDATE_VEHICLE_REQUEST";
export const UPDATE_VEHICLE_SUCCESS = "UPDATE_VEHICLE_SUCCESS";
export const UPDATE_VEHICLE_FAILURE = "UPDATE_VEHICLE_FAILURE";

export const GET_VEHICLE_BY_ID_REQUEST = "GET_VEHICLE_BY_ID_REQUEST";
export const GET_VEHICLE_BY_ID_SUCCESS = "GET_VEHICLE_BY_ID_SUCCESS";
export const GET_VEHICLE_BY_ID_FAILURE = "GET_VEHICLE_BY_ID_FAILURE";

export const UPDATE_VEHICLE_STATUS_REQUEST = "UPDATE_VEHICLE_STATUS_REQUEST";
export const UPDATE_VEHICLE_STATUS_SUCCESS = "UPDATE_VEHICLE_STATUS_SUCCESS";
export const UPDATE_VEHICLE_STATUS_FAILURE = "UPDATE_VEHICLE_STATUS_FAILURE";

export const GET_VEHICLE_BY_NUMBER_REQUEST = "GET_VEHICLE_BY_NUMBER_REQUEST";
export const GET_VEHICLE_BY_NUMBER_SUCCESS = "GET_VEHICLE_BY_NUMBER_SUCCESS";
export const GET_VEHICLE_BY_NUMBER_FAILURE = "GET_VEHICLE_BY_NUMBER_FAILURE";
